"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _debounce = _interopRequireDefault(require("./debounce"));

var _memoize = _interopRequireDefault(require("./memoize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var ScrollSpy =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollSpy, _React$Component);

  function ScrollSpy(props, context) {
    var _this;

    _classCallCheck(this, ScrollSpy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollSpy).call(this, props, context));
    _this.handlePointerOver = (0, _debounce.default)(_this.handlePointerOver.bind(_assertThisInitialized(_assertThisInitialized(_this))), 300);
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.emitScroll = (0, _memoize.default)(function (initial, fraction, width) {
      _this.props.onScroll && _this.props.onScroll({
        initial: initial,
        fraction: fraction,
        width: width
      });
    });
    return _this;
  }

  _createClass(ScrollSpy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$targetRef = this.props.targetRef;
      _this$props$targetRef = _this$props$targetRef === void 0 ? {} : _this$props$targetRef;
      var current = _this$props$targetRef.current;

      if (current) {
        current.addEventListener('pointerover', this.handlePointerOver, {
          passive: true
        });
        current.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
        this.emitInitialScrollEvent(current);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.targetRef !== this.props.targetRef) {
        var _prevProps$targetRef = prevProps.targetRef;
        _prevProps$targetRef = _prevProps$targetRef === void 0 ? {} : _prevProps$targetRef;
        var prevCurrent = _prevProps$targetRef.current;
        var _this$props$targetRef2 = this.props.targetRef;
        _this$props$targetRef2 = _this$props$targetRef2 === void 0 ? {} : _this$props$targetRef2;
        var current = _this$props$targetRef2.current;

        if (prevCurrent) {
          prevCurrent.removeEventListener('pointerover', this.handlePointerOver);
          prevCurrent.removeEventListener('scroll', this.handleScroll);
        }

        if (current) {
          current.addEventListener('pointerover', this.handlePointerOver, {
            passive: true
          });
          current.addEventListener('scroll', this.handleScroll, {
            passive: true
          });
          this.emitInitialScrollEvent(current);
        }
      }
    }
  }, {
    key: "emitInitialScrollEvent",
    value: function emitInitialScrollEvent(current, waited) {
      var _this2 = this;

      if (!waited && current.scrollWidth === current.offsetWidth) {
        // HACK: Chrome 66 will initially say scrollWidth equals to offsetWidth, until some time later
        setTimeout(function () {
          return _this2.emitInitialScrollEvent(current, true);
        });
      }

      this.handleScroll({
        target: current
      }, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props$targetRef3 = this.props.targetRef;
      _this$props$targetRef3 = _this$props$targetRef3 === void 0 ? {} : _this$props$targetRef3;
      var current = _this$props$targetRef3.current;
      current && current.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "handlePointerOver",
    value: function handlePointerOver() {
      // We need to send "onScroll" because "scrollWidth" might have changed
      // For example, the container resized, the scroll width will be incorrect
      // We will debounce to prevent "pointerOver" calculating too often
      // We will memoize to prevent firing unnecessary "onScroll"
      var _this$props$targetRef4 = this.props.targetRef;
      _this$props$targetRef4 = _this$props$targetRef4 === void 0 ? {} : _this$props$targetRef4;
      var current = _this$props$targetRef4.current;
      this.handleScroll({
        target: current
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(_ref) {
      var target = _ref.target;
      var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetWidth = target.offsetWidth,
          scrollLeft = target.scrollLeft,
          scrollWidth = target.scrollWidth;
      this.emitScroll(initial, "".concat(scrollWidth === offsetWidth ? 0 : scrollLeft / (scrollWidth - offsetWidth) * 100, "%"), "".concat(offsetWidth / scrollWidth * 100, "%"));
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);

  return ScrollSpy;
}(_react.default.Component);

exports.default = ScrollSpy;